import { Grid, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import { notificationSettingsKeys } from "../../../../../api/queryKeys";
import CustomToolTip from "../../../../../components/CustomTooltip";
import ResponsiveCheckbox from "../../../../../components/ResponsiveCheckbox";
import ToggleSwitch from "../../../../../components/ToggleSwitch";
import { EnabledMethodsContext } from "../../CustomNotificationPage";

export const inputType = {
  TOGGLE: "toggle",
  CHECKBOX: "checkbox",
};

export default function SettingsList({ setFetchStatus, settingsData }) {
  const { updateNotificationSetting } = useAPI();
  const queryClient = useQueryClient();
  const enabledMethodsByName = useContext(EnabledMethodsContext);

  const handleUpdate = (method, settingId, newValue) =>
    updateNotificationSetting(method, settingId, newValue).then(() => {
      queryClient.invalidateQueries({
        queryKey: notificationSettingsKeys.all,
      });
    });

  return (
    <Grid container direction="column" gap={0.5}>
      {Object.entries(settingsData).map(([settingId, settingData]) => (
        <Grid item key={settingId}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography
                variant={
                  settingData.type === inputType.CHECKBOX
                    ? "body2"
                    : "subtitle2"
                }
              >
                {settingData.title}
              </Typography>
            </Grid>
            <Grid item>
              <Grid container direction="row" gap={5} paddingRight={0.5}>
                {Object.keys(settingData.valueByMethod).map((method) => (
                  <CustomToolTip
                    title="This setting is managed by your organization admin"
                    disableHoverListener={enabledMethodsByName[method]}
                  >
                    <Grid item key={method}>
                      {settingData.type === inputType.CHECKBOX ? (
                        <ResponsiveCheckbox
                          defaultValue={settingData.valueByMethod[method]}
                          updateFunction={(newValue) =>
                            handleUpdate(method, settingId, newValue)
                          }
                          setFetchStatus={setFetchStatus}
                          isPermanentlyDisabled={!enabledMethodsByName[method]}
                        />
                      ) : settingData.type === inputType.TOGGLE ? (
                        <ToggleSwitch
                          defaultValue={settingData.valueByMethod[method]}
                          updateFunction={(newValue) =>
                            handleUpdate(method, settingId, newValue)
                          }
                          setFetchStatus={setFetchStatus}
                          isPermanentlyDisabled={!enabledMethodsByName[method]}
                        />
                      ) : null}
                    </Grid>
                  </CustomToolTip>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}
